import { render, staticRenderFns } from "./pointDeduct.vue?vue&type=template&id=3922eaac"
import script from "./pointDeduct.vue?vue&type=script&lang=js"
export * from "./pointDeduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports